import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import "./header.css";
import MilkitLogo from "../../assets/img/milkit-logo-text.png";
import MacrostrategyModal from './components/MacrostrategyModal';
import ReferModal from './components/ReferModal';
import TerminalModal from './components/TerminalModal';
import AccountModal from './components/AccountModal';
import { useAccount } from 'wagmi';
import { useMediaQuery } from '@mui/material';
import MobileMenu from './components/MobileMenu';
import { useTranslation } from 'react-i18next';

const HeaderContainer = styled.div`
display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 64px;
    margin-top: 10px;
    padding: 0px 32px;
    position: relative;
    `;
const HeaderNav = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    flex-grow: 1;
    margin-left: 32px;
`;

const HeaderButton = styled.button`
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    font-family: inherit;
    font-size: 13.33px;
    background: rgb(16, 44, 57);
    color: #507c83;
    border: 2px solid #507c83;
    opacity: 1;
    // max-height: 38.2px;
    transition: 0.2s ease-in-out, transform 0.1s ease-in-out;

    &:hover {
       background: rgb(26, 61, 79);
    }
`;

const HeaderLink = styled.a`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 24px;
    font-size: 14px;
    transition: opacity 0.2s ease-in-out;
    color: #fff;
    text-transform: uppercase;
`;

const Header = () => {
    const { t, i18n } = useTranslation();
    const account = useAccount()
    const [showMacrostrategyModal, setShowMacrostrategyModal] = useState(false);
    const [showRefer, setShowRefer] = useState(false);
    const [showTerminalModal, setShowTerminalModal] = useState(false);
    const [showAccountModal, setShowAccountModal] = useState(false);
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const isMediumScreen = useMediaQuery('(max-width: 1380px)');
    const isMediumSmallScreen = useMediaQuery('(max-width: 1124px)');
    const isSmallScreen = useMediaQuery('(max-width: 880px)');


    return (
        <HeaderContainer>
            {showTerminalModal && (
                <TerminalModal open={showTerminalModal} onClose={() => setShowTerminalModal(false)} />
            )}
            {showMacrostrategyModal && (
                <MacrostrategyModal open={showMacrostrategyModal} onClose={() => setShowMacrostrategyModal(false)} />
            )}
            {showRefer && (
                <ReferModal open={showRefer} onClose={() => setShowRefer(false)} />
            )}
            {showAccountModal && (
                <AccountModal open={showAccountModal} onClose={() => setShowAccountModal(false)} />
            )}
            {showMobileMenu && (
                <MobileMenu 
                open={showMobileMenu} 
                onClose={() => setShowMobileMenu(false)} 
                setShowMacrostrategyModal={setShowMacrostrategyModal}
                setShowRefer={setShowRefer}
                setShowTerminalModal={setShowTerminalModal}
                setShowAccountModal={setShowAccountModal}
                account={account} 
                />
            )}


            <div className="flex items-center gap-4">
                <a href="/">
                    <img
                        alt="Milkit Logo"
                        width={140}
                        height={32}
                        src={MilkitLogo}
                        className="mr-4"
                        style={{ width: "150px", height: "36px", marginTop: "-6px" }}
                    />
                </a>
            </div>
            <HeaderNav>
                <HeaderLink
                    target="_self"
                    href="/farms"
                    style={{ display: isSmallScreen ? "none" : "flex" }}
                >
                    {t("menu_header.farms")}
                </HeaderLink>
                <HeaderLink href="/mystery-box" style={{ display: isSmallScreen ? "none" : "flex" }}>
                    {t("menu_header.mystery_box")}
                </HeaderLink>
                <HeaderLink href="/leaderboard" style={{ display: isSmallScreen ? "none" : "flex" }}>
                    {t("menu_header.leaderboard")}
                </HeaderLink>
                <HeaderLink
                    target="_blank"
                    href="https://www.shadow.so/trade?inputCurrency=0x0000000000000000000000000000000000000000&outputCurrency=0xA052cC4dD2138504Dd89E723D72636D491b4cEd9"
                    style={{ display: isMediumSmallScreen ? "none" : "flex" }}
                >
                    {t("menu_header.trade")}
                </HeaderLink>
                <HeaderLink href="/disclaimer" style={{ display: isMediumSmallScreen ? "none" : "flex" }}>
                    {t("menu_header.disclaimer")}
                </HeaderLink>
                {/* <HeaderLink target="_blank" href="https://docs.milkit.finance/" style={{ display: isMediumSmallScreen ? "none" : "flex" }}>
                    {t("menu_header.about")}
                </HeaderLink> */}
                <div style={{ flexGrow: "1" }} />
                <div style={{ display: !isSmallScreen ? "none" : "flex" }}>
                    <div className="sc-9bbd01c4-1 izPSem" style={{ display: "flex", gap: "10px", zIndex: 100 }}>
                        <HeaderButton onClick={() => setShowMobileMenu(!showMobileMenu)}>
                            {t("menu_header.menu")}
                        </HeaderButton>
                    </div>
                </div>
                <div style={{ display: isSmallScreen ? "none" : "flex" }}>
                    <div className="sc-9bbd01c4-1 izPSem" style={{ display: "flex", gap: "10px" }}>
                        {/* <HeaderButton onClick={() => setShowMacrostrategyModal(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
                            MACROSTRATEGY
                        </HeaderButton> */}
                        <HeaderButton onClick={() => setShowRefer(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
                            {t("menu_header.refer")}
                        </HeaderButton>
                        <HeaderButton onClick={() => setShowTerminalModal(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
                            <svg width={14} height={14} viewBox="0 0 143 148" fill="none">
                                <path
                                    d="M18 42V108H116L117 109V124L116 125H112L110 123V117H3L2 118V137L3 138V139L4 140H8L9 141V145L10 146H118V141L119 140H124L125 139V42H18Z"
                                    fill="#507c83"
                                    stroke="#507c83"
                                    strokeWidth={4}
                                />
                                <path
                                    d="M127 12L126 13V26L127 27H131L132 28V39L133 40V41L134 42H139L140 41V40L141 39V13L140 12H127Z"
                                    fill="#507c83"
                                    stroke="#507c83"
                                    strokeWidth={4}
                                />
                                <path
                                    d="M48 3L47 4H10L9 5V11L8 12H3L2 13V32L3 33H118V13L119 12H124L126 10V9L125 8L126 7L125 6V4H49L48 3Z"
                                    fill="#507c83"
                                    stroke="#507c83"
                                    strokeWidth={4}
                                />
                            </svg>
                        </HeaderButton>
                        <ConnectButton.Custom>
                            {({
                                account,
                                chain,
                                openAccountModal,
                                openChainModal,
                                openConnectModal,
                                authenticationStatus,
                                mounted,
                            }) => {
                                const ready = mounted && authenticationStatus !== 'loading';
                                const connected = ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated');

                                return (
                                    <HeaderButton {...(!ready && { 'aria-hidden': true, style: { opacity: 0, pointerEvents: 'none', userSelect: 'none' } })} onClick={() => {
                                        if (!connected) {
                                            openConnectModal();
                                        } else if (chain?.unsupported) {
                                            openChainModal();
                                        } else {
                                            setShowAccountModal(true);
                                        }
                                    }}>
                                        {(() => {
                                            if (!connected) {
                                                return (
                                                    <div
                                                    // onClick={openConnectModal}
                                                    >
                                                        {t("menu_header.connect_wallet")}
                                                    </div>
                                                );
                                            }

                                            if (chain.unsupported) {
                                                return (
                                                    <div
                                                    // onClick={openChainModal}
                                                    >
                                                        [{t("menu_header.wrong_network")}]
                                                    </div>
                                                );
                                            }

                                            return (
                                                // <div onClick={openAccountModal}>
                                                <div>
                                                    <svg width={15} height={15} viewBox="0 0 86 100" fill="none">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M51.2996 12.4814H34.6356V4.14941H51.2996V12.4814ZM59.6355 20.8134V12.4814H51.2996V20.8134H59.6355ZM59.6355 37.4814V20.8134H67.9675V37.4814H59.6355ZM51.2996 45.8134V37.4814H59.6355V45.8134H51.2996ZM34.6356 45.8134H51.2996V54.1493H34.6356V45.8134ZM26.2997 37.4814V45.8134H34.6356V37.4814H26.2997ZM26.2997 20.8134V37.4814H17.9677V20.8134H26.2997ZM26.2997 20.8134H34.6356V12.4814H26.2997V20.8134ZM63.7997 87.4814H22.1357V79.1494H9.6357V70.8135H17.9677V62.4815H30.4677V54.1495H17.9677V62.4815H9.6357V70.8135H1.2998V79.1494H9.6357V87.4814H22.1357V95.8134H63.7997V87.4814ZM76.2997 79.1494V87.4814H63.7997V79.1494H76.2997ZM76.2997 70.8135H84.6356V79.1494H76.2997V70.8135ZM67.9677 62.4815V70.8135H76.2997V62.4815H67.9677ZM67.9677 62.4815H55.4677V54.1495H67.9677V62.4815Z"
                                                            fill="#507c83"
                                                        />
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M51.2996 9.48141H34.6356V1.14941H51.2996V9.48141ZM59.6355 17.8134V9.48141H51.2996V17.8134H59.6355ZM59.6355 34.4814V17.8134H67.9675V34.4814H59.6355ZM51.2996 42.8134V34.4814H59.6355V42.8134H51.2996ZM34.6356 42.8134H51.2996V51.1493H34.6356V42.8134ZM26.2997 34.4814V42.8134H34.6356V34.4814H26.2997ZM26.2997 17.8134V34.4814H17.9677V17.8134H26.2997ZM26.2997 17.8134H34.6356V9.48141H26.2997V17.8134ZM63.7997 84.4814H22.1357V76.1494H9.6357V67.8135H17.9677V59.4815H30.4677V51.1495H17.9677V59.4815H9.6357V67.8135H1.2998V76.1494H9.6357V84.4814H22.1357V92.8134H63.7997V84.4814ZM76.2997 76.1494V84.4814H63.7997V76.1494H76.2997ZM76.2997 67.8135H84.6356V76.1494H76.2997V67.8135ZM67.9677 59.4815V67.8135H76.2997V59.4815H67.9677ZM67.9677 59.4815H55.4677V51.1495H67.9677V59.4815Z"
                                                            fill="#507c83"
                                                        />
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M51.2996 15.4814H34.6356V7.14941H51.2996V15.4814ZM59.6355 23.8134V15.4814H51.2996V23.8134H59.6355ZM59.6355 40.4814V23.8134H67.9675V40.4814H59.6355ZM51.2996 48.8134V40.4814H59.6355V48.8134H51.2996ZM34.6356 48.8134H51.2996V57.1493H34.6356V48.8134ZM26.2997 40.4814V48.8134H34.6356V40.4814H26.2997ZM26.2997 23.8134V40.4814H17.9677V23.8134H26.2997ZM26.2997 23.8134H34.6356V15.4814H26.2997V23.8134ZM63.7997 90.4814H22.1357V82.1494H9.6357V73.8135H17.9677V65.4815H30.4677V57.1495H17.9677V65.4815H9.6357V73.8135H1.2998V82.1494H9.6357V90.4814H22.1357V98.8134H63.7997V90.4814ZM76.2997 82.1494V90.4814H63.7997V82.1494H76.2997ZM76.2997 73.8135H84.6356V82.1494H76.2997V73.8135ZM67.9677 65.4815V73.8135H76.2997V65.4815H67.9677ZM67.9677 65.4815H55.4677V57.1495H67.9677V65.4815Z"
                                                            fill="#507c83"
                                                        />
                                                    </svg>
                                                </div>
                                            );
                                        })()}
                                    </HeaderButton>
                                );
                            }}
                        </ConnectButton.Custom>
                    </div>
                </div>
            </HeaderNav>
        </HeaderContainer>
    );
};

export default Header;
